import DivisionPage from "./DivisionPage";

export default function PassengerTransport() {
  return <DivisionPage slug="passenger-transport" />;
}
